/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from "react";
import { TiPencil } from "react-icons/ti";
import { BsCheckCircleFill } from "react-icons/bs";
import { ImCross } from "react-icons/im";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";

import { setConfigData } from "../../../../Retrofit/store/slices/retrofit";
import { setCartesianConfigData } from "../../../../Cartesian/store/slices/cartesian";

import { logEvent } from "../../../utils/api/api";
import t from "../../../utils/translation/translator";
import isFilenameValid from "../../../../Retrofit/utils/filenameValidator";
import {
  selectEventsData,
  selectUpdatingConfiguration,
  updateConfiguration,
  selectConfigurationType
} from "../../../store/slices/common";
import { getCurrentConfiguration, getCurrentStep } from "../../../utils/api/common";
import { setMc12ConfigData } from "../../../../Mc12/store/slices/mc12";
import { setIntegratedDrivesConfigData } from "../../../../IntegratedDrives/store/slices/integrated_drives";

const EditableConfigurationName = ({ blue, smallInput, ...props }) => {
  const configurationType = useSelector(selectConfigurationType);
  const configuration = getCurrentConfiguration();
  const updatingConfiguration = useSelector(selectUpdatingConfiguration);
  const [modeEdition, setModeEdition] = useState(false);
  const [newName, setNewName] = useState(configuration?.configData?.configName);
  const dispatch = useDispatch();

  const handleClickEditName = () => {
    setNewName(configuration?.configData?.configName);
    setModeEdition(true);
  };

  const eventsData = useSelector(selectEventsData);
  const currentStep = getCurrentStep();

  const handleConfirmSaveName = () => {
    if (!newName) {
      return;
    }
    logEvent(
      eventsData.locale,
      eventsData.types.rename,
      currentStep.label === t("msizer.ui.stepper.save_and_share")
        ? eventsData.tags.finalizeStep
        : eventsData.tags.applicationSettingsStep,
      configuration?.configId
    );

    switch (configurationType) {
      case "CARTESIAN":
        dispatch(
          setCartesianConfigData({
            ...configuration.configData,
            configName: newName
          })
        );
        break;
      case "MC12":
        dispatch(
          setMc12ConfigData({
            ...configuration.configData,
            configName: newName
          })
        );
        break;
      case "INTEGRATED_DRIVES":
        dispatch(
          setIntegratedDrivesConfigData({
            ...configuration.configData,
            configName: newName
          })
        );
        break;
      default:
        dispatch(
          setConfigData({
            ...configuration.configData,
            configName: newName
          })
        );
    }

    setModeEdition(false);
    dispatch(updateConfiguration());
  };

  const handleCancelSaveName = () => {
    setModeEdition(false);
  };

  const handleSetName = (value) => {
    if (isFilenameValid(value)) {
      setNewName(value);
    }
  };

  return (
    <div
      className={`text-lg flex items-center font-bold justify-between max-w-[80%]
      ${updatingConfiguration ? "opacity-50 pointer-events-none" : ""}`}
      {...props}
    >
      {modeEdition && (
        <div className="flex items-center space-x-2">
          <input
            required
            type="text"
            pattern="^[^<>:/\\|?*\x00-\x1F]+$"
            value={newName}
            onChange={(e) => handleSetName(e.target.value)}
            className={`invalid:border-red-500 border-gray-400 focus:border-gray-800 focus:ring-0 p-[0.25rem]  ${
              smallInput ? "max-w-[50%]" : ""
            }`}
            // on press enter => save
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.stopPropagation();
                handleConfirmSaveName();
              }
            }}
          />
          <ImCross
            className="cursor-pointer text-gray-400 opacity-90 hover:opacity-100"
            onClick={handleCancelSaveName}
          />
          <BsCheckCircleFill
            className="cursor-pointer text-secondary
 text-xl opacity-90 hover:opacity-100"
            onClick={handleConfirmSaveName}
          />
        </div>
      )}
      {!modeEdition && (
        <div onClick={handleClickEditName} className="group flex items-center space-x-2 max-w-full">
          <span
            title={configuration?.configData?.configName}
            className={`border-[1px] border-transparent group-hover:border-gray-300 p-[0.25rem] whitespace-nowrap overflow-hidden text-ellipsis w-full ${
              blue ? "text-secondary font-normal" : "text-gray-600"
            }`}
          >
            {configuration?.configData?.configName}
          </span>
          <TiPencil className="text-secondary cursor-pointer" />
        </div>
      )}
    </div>
  );
};

EditableConfigurationName.propTypes = {
  blue: PropTypes.bool,
  smallInput: PropTypes.bool
};

EditableConfigurationName.defaultProps = {
  blue: false,
  smallInput: false
};

export default EditableConfigurationName;
